export enum ObjectMode {
  translateObject = "translate",
  rotateObject = "rotate",
}
